import { Injectable, inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContactUsModel } from '../Model/contactUs.model';
import { environment } from '../../../../../environment/environment';
import { SharedApiService } from '../../../service/util.service';


@Injectable({
  providedIn: 'root'
})
export class ContactService {

  private apiUrl = `${environment.apiUrl}ContactUsMessage/CreateMessage`

  private http = inject(HttpClient)

  createMessage(messageData: ContactUsModel): Observable<any> {
    return this.http.post<any>(this.apiUrl, messageData);
  }
}